<template>
    <div class="page-body">
        <div class="search-list">
            <a-table :row-selection="rowSelection" :dataSource="formState.articleList" :columns="columns"
                rowKey="article_id" row-class-name="article-list" :pagination="pagination" @change="onLoadList">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.dataIndex === 'action'">
                        <span>
                            <a-button type="link" @click="showRes(record.article_id)">查看</a-button>
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'category'">
                        <span>
                            {{ record.category.category_name }}
                        </span>
                    </template>
                    <template v-if="column.dataIndex === 'content_type'">
                        <span v-if="record.content_type == 'video'">
                            视频
                        </span>
                        <span v-else-if="record.content_type == 'image'">
                            图片
                        </span>
                        <span v-else-if="record.content_type == 'article'">
                            文章
                        </span>
                        <span v-else-if="record.content_type == 'audio'">
                            音频
                        </span>
                    </template>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    import {
        defineComponent,
        ref,
        onMounted,
        computed,
        reactive,
        watch
    } from "vue";

    import {
        useRoute,
        useRouter
    } from "vue-router";
    import * as Api from "@/views/resource/api";

    export default defineComponent({
        components: {},
        setup() {
            const route = useRoute();
            const router = useRouter();

            watch(
                () => route.query.keyword,
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        formState.keyword = newVal;
                        onLoadList();
                    }
                }
            )

            const formState = reactive({
                category_id: 1,
                keyword: "",
                betweenTime: [],
                page: 1,
                articleList: [],

                total: 0,
                current_page: 0,
                per_page: 0,
                year: ""
            });

            
            formState.keyword = ref(route.query.keyword ? route.query.keyword : '');


            // 初始化
            onMounted(() => {
                onLoadList();
            });

            // 根据条件获取列表数据
            const onLoadList = (page, filters, sorter) => {
                Api.getArticleList({
                    page: page ? page.current : 1,
                    limit: page ? page.pageSize : 10,
                    keyword: formState.keyword,
                    betweenTime: formState.betweenTime,
                    sorter: sorter ? sorter : false,
                }).then((res) => {
                    formState.articleList = res.data.data;
                    formState.total = res.data.total;
                    formState.per_page = res.data.per_page;
                    formState.current_page = res.data.current_page;
                });
            };

            // 列表分页数据
            const pagination = computed(() => ({
                total: formState.total,
                current: formState.current_page,
                pageSize: formState.per_page,
            }));

            const rowSelection = {
                onChange: (selectedRowKeys, selectedRows) => {
                    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                }
            };

            // 查看资料
            const showRes = (article_id) => {
                router.push({
                    path: '/resource/show',
                    query: {
                        id: article_id
                    },
                });
            }

            return {
                rowSelection,
                formState,
                pagination,
                onLoadList,
                showRes,
                columns: [{
                        title: '序号',
                        dataIndex: 'article_id',
                        key: 'article_id',
                    },
                    {
                        title: '项目名称',
                        dataIndex: 'title',
                        key: 'title',
                    },
                    {
                        title: '年代',
                        dataIndex: 'year',
                        key: 'year',
                    },
                    {
                        title: '资源形式',
                        dataIndex: 'content_type',
                        key: 'content_type',
                    },
                    {
                        title: '作者',
                        dataIndex: 'author',
                        key: 'author',
                    },
                    {
                        title: "操作",
                        dataIndex: "action",
                        key: "action",
                    },
                ],
            };
        },
    });
</script>

<style scoped lang="less">
    .home-body {
        padding-top: 100px;
        background-color: #ECECEC;
        height: 100vh;

        .home-bg {
            width: 100%;
        }

        .home-content {
            .home-content-body {
                width: 80%;
                margin: 0 auto;
                background-color: #fff;
                padding: 50px;
                margin-top: -200px;
                position: relative;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;

                .dept-box {
                    display: block;
                    text-align: center;
                    margin-bottom: 50px;

                    .dept-number {
                        display: inline-block;
                        width: 60px;
                        height: 60px;
                        line-height: 60px;
                        text-align: center;
                        border-radius: 50%;
                        font-size: 18px;
                        border: 1px solid #7D1A15;
                        color: #7D1A15;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }

                    .dept-name {
                        color: #7D1A15;
                        font-size: 16px;
                    }
                }
            }
        }
    }

    .search-list {
        width: 1200px;
        padding-top: 120px;
        margin: 0 auto;
    }
</style>